/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:b64496a4-9962-4472-8382-472c84e610a2",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vvsgWdXDl",
    "aws_user_pools_web_client_id": "282ve82luun8fq6jhu1fesi3ll",
    "oauth": {
        "domain": "easy-mes-dev-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://easy-mes.com/,https://www.easy-mes.com/,https://dr7vkx77u2cwh.cloudfront.net/,http://localhost:3000/",
        "redirectSignOut": "https://easy-mes.com/,https://www.easy-mes.com/,https://dr7vkx77u2cwh.cloudfront.net/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "AMAZON"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "vcapp1-20260515120704-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dr7vkx77u2cwh.cloudfront.net",
    "aws_user_files_s3_bucket": "vcapp-photo-deva1745-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "cognitoAdminApi",
            "endpoint": "https://jb2ia311hb.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
